import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { IconWrapper } from '@cognite/cogs-utils';

var MenuItemIcon = function MenuItemIcon(_a) {
  var className = _a.className,
    showOnHover = _a.showOnHover,
    icon = _a.icon,
    otherProps = __rest(_a, ["className", "showOnHover", "icon"]);
  return icon ? jsx("div", Object.assign({
    className: "cogs-v10 cogs-menu-item__column"
  }, otherProps, {
    children: jsx(IconWrapper, {
      size: 16,
      className: classNames(className, showOnHover && 'cogs-menu--show-on-hover'),
      children: icon
    })
  })) : null;
};

export { MenuItemIcon };
